export default __webpack_public_path__ + "static/media/github.8206d273.svg";